import React from 'react';
import styled from 'styled-components';

import PlayerErrorImage from '../../assets/cn-player-error.jpg';
import Button from '../Button';

const Container = styled.div`
    max-width: 90%;
    aspect-ratio: 16/9;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    z-index: 1;
    background-color: black;

    h2 {
        color: #fff;
        font-size: 45px;
        font-weight: bold;
        text-align: center;
        margin: 0px;
        padding: 0px;
        margin-bottom: 12px;
    }

    p {
        color: rgb(255, 255, 255);
        font-size: 18px;
        text-align: center;
        padding: 0px;
        margin: 0px;
        margin-bottom: 12px;
        max-width: 350px;
    }

    img {
        max-height: 55%;
        object-fit: contain;
    }
`;

function PlayerError({
    title,
    errorMessage,
    onClickButton,
    buttonText,
    hideHero,
}) {
    return (
        <Container>
            <h2>{title || 'Oops'}</h2>

            <p>{errorMessage || ''}</p>

            {!hideHero && (
                <img
                    width="33%"
                    height="auto"
                    src={PlayerErrorImage}
                    alt="Scared Gumball"
                />
            )}

            {buttonText && onClickButton && (
                <Button
                    secondary
                    margin="1.5rem auto 0 auto"
                    onClick={onClickButton}
                >
                    {buttonText}
                </Button>
            )}
        </Container>
    );
}

export default PlayerError;
